// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"styles_tabBar__29IaW","tab":"styles_tab__1rwSc","activeTab":"styles_activeTab__2rxCK"};